// Disable auto highlighting
// https://github.com/PrismJS/prism/issues/765
if (typeof window !== 'undefined') {
  window.Prism = window.Prism || {};
  window.Prism.manual = true;
}
